import React from 'react';

const Home = () => {
  return (
    <div 
      className="h-screen bg-cover bg-center bg-no-repeat relative" 
      style={{ backgroundImage: "url('/home.png')" }}
    >
      <header className="absolute mt-24 left-1/2 transform -translate-x-1/2 text-white py-2 px-4 rounded-md">
        <h1 
          className="text-4xl font-extrabold text-center bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-transparent bg-clip-text drop-shadow-lg"
        >
          Tere tulemast Haapsalu Veevärgi rakendusse!
        </h1>
      </header>
    </div>
  );
};

export default Home;
